<template>
  <b-container>
    <b-row>
      <b-col
        cols="6"
        class="text-right">
        <span class="item-title">{{ $t('message.lblDieta') }}{{ index + 1 }}</span>
        <button
          type="button"
          class="remove-item btn btn-danger "
          @click="del">
          <i class="fas fa-minus" />
        </button>
      </b-col>
    </b-row>

    <b-row>
      <b-col>

        <b-form-group
          :name="`items.$each.${index}.priezvisko_meno`"
          class="required"
          :label="$t('message.lblPriezMeno')">
          <template slot-scope="{ attrs, listeners }">
            <b-form-input
              class="alignL"
              v-bind="attrs"
              v-model.trim="items[index].priezvisko_meno"
              v-on="listeners" />
          </template>
        </b-form-group>

        <b-form-group
          :name="`items.$each.${index}.rc`"
          class="required"
          :label="$t('message.lblRc')">
          <template slot-scope="{ attrs, listeners }">
            <b-form-input
              class="alignL"
              v-bind="attrs"
              placeholder="xxxxxx/yyyy"
              v-model.trim="items[index].rc"
              @input="setListMonths"
              v-on="listeners" />
          </template>
        </b-form-group>

      </b-col>
      <b-col>

        <div class="row">
          <span style="margin-bottom: 1%">
            Na dieťa uplatňujem:
          </span>
        </div>

        <div class="row">
          <b-form-group
            :name="`items.$each.${index}.ks`"
            input-cols="11"
            class="checkbox-group">
            <template slot-scope="{ attrs, listeners }">
              <b-form-checkbox
                v-bind="attrs"
                v-model="items[index].ks"
                plain
                value="1"
                unchecked-value="0"
                v-on="listeners">
                <label class="acceptCss">{{ $t('message.ks') }}</label>
              </b-form-checkbox>
            </template>
          </b-form-group>

          <b-form-group
            :name="`items.$each.${index}.bonus`"
            input-cols="11"
            class="checkbox-group">
            <template slot-scope="{ attrs, listeners }">
              <b-form-checkbox
                v-bind="attrs"
                v-model="items[index].bonus"
                plain
                value="1"
                unchecked-value="0"
                @change="setNull(items[index])"
                v-on="listeners">
                <label class="acceptCss">{{ $t('message.lblDanBonus') }}</label>
              </b-form-checkbox>
            </template>
          </b-form-group>
        </div>

        <div
          v-if="items[index].bonus == '1'"
          class="row">
          <b-form-group
            :name="`items.$each.${index}.fullYear`"
            input-cols="12">
            <template slot-scope="{ attrs, listeners }">
              <b-form-radio-group
                v-bind="attrs"
                v-model="items[index].fullYear"
                plain
                v-on="listeners">
                <b-form-radio :disabled="rokDisabled" value="1">{{ $t('message.lblRok') }}</b-form-radio>
                <b-form-radio value="0">{{ $t('message.lblMesiace') }}</b-form-radio>
              </b-form-radio-group>
            </template>
          </b-form-group>

          <b-form-group
            v-if="items[index].fullYear != 1"
            :name="`items.$each.${index}.months`"
            input-cols="12">
            <template slot-scope="{ attrs, listeners }">
              <b-form-checkbox-group
                v-bind="attrs"
                v-model="items[index].months"
                :options="listMonths"
                plain
                class="p12"
                v-on="listeners"/>
            </template>
          </b-form-group>
        </div>

      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import bFormGroup from '@/components/form-group-col6';

export default {

  components: {
    bFormGroup,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    }
  },

  data() {
    return {
      listMonths: [
        { text: 'I.', value: '1', disabled: false }, { text: 'II.', value: '2', disabled: false },
        { text: 'III.', value: '3', disabled: false }, { text: 'IV.', value: '4', disabled: false },
        { text: 'V.', value: '5', disabled: false }, { text: 'VI.', value: '6', disabled: false },
        { text: 'VII.', value: '7', disabled: false }, { text: 'VIII.', value: '8', disabled: false },
        { text: 'IX.', value: '9', disabled: false }, { text: 'X.', value: '10', disabled: false },
        { text: 'XI.', value: '11', disabled: false }, { text: 'XII.', value: '12', disabled: false },
      ],
      rokDisabled: false
    };
  },

  methods: {
    del() {
      this.items[this.index].deleted = true;
      this.items[this.index].ks = 0;
    },
    setNull(item) {
      item.months = [];
      item.fullYear = 1;
    },
    setListMonths () {
      const rc = this.items[this.index].rc
      const birthYear = rc.substring(0,2)
      let i = this.items
      let rcBirthMonth = parseInt(rc.substring(2, 4));

      if (rcBirthMonth > 50) {
        rcBirthMonth = rcBirthMonth - 50
      }
      this.rokDisabled = false

      if (birthYear === '20' || birthYear === '95') {
        this.rokDisabled = true
        this.setDisabledAttr(birthYear, rcBirthMonth);
      } else {
        this.listMonths.forEach((item) => {
          item.disabled = false;
        })
      }
    },
    setDisabledAttr (birthYear, rcBirthMonth) {
      switch (birthYear) {
        case '19':
            this.listMonths.forEach((item) => {
              item.disabled = parseInt(item.value) < rcBirthMonth
              if (item.disabled) {
                this.items[this.index].months = this.items[this.index].months.filter(x => x !== item.value)
              }
            })
          break;
        case '94':
            this.listMonths.forEach((item) => {
              item.disabled = parseInt(item.value) > rcBirthMonth
              if (item.disabled) {
                this.items[this.index].months = this.items[this.index].months.filter(x => x !== item.value)
              }
            })
          break;
      }
    }
  },
};
</script>

<style scoped>
.p12 .form-check {
    width: 12%;
}
.p12 {
  padding-left: 1%;
}
.form-check-inline {
  align-items: baseline;
  padding-left: 3%;
}
.item-title {
    margin-top: 3.5%;
    text-align: right;
    font-weight: bold;
}
.pull-right {
    float: right;
}
.remove-item {
    display: inline !important;
    margin-left: 1em !important;
}
.checkbox-group {
  float: left;
  margin-bottom: 0;
}
.form-check-input:disabled ~ .form-check-label {
  color: #6c757d!important;
}
</style>
